export default __webpack_public_path__ + "static/media/grafema_clivitalbio_13.706f17a0.jpg";